import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyActions, NOTIFICATION_TYPE } from "@lemonadetraining/web-shared";
import { toast } from "sonner";

interface NotifyState {
  activate: boolean;
  severity: string;
  title: string;
  message: string;
}

// Toasts close after 5 s; a long one gets time to be read.
const LONG_DESCRIPTION = 120;

const Notification = () => {
  const dispatch = useDispatch();
  const notify: NotifyState = useSelector((state: any) => state.notify);

  useEffect(() => {
    if (!notify.activate) return;

    const description = notify.message || undefined;
    const options =
      description && description.length > LONG_DESCRIPTION
        ? { description, duration: 8000 }
        : { description };

    switch (notify.severity) {
      case NOTIFICATION_TYPE.success:
        toast.success(notify.title, options);
        break;
      case NOTIFICATION_TYPE.error:
        toast.error(notify.title, options);
        break;
      case NOTIFICATION_TYPE.warning:
        toast.warning(notify.title, options);
        break;
      case NOTIFICATION_TYPE.info:
      default:
        toast.info(notify.title, options);
        break;
    }

    dispatch(notifyActions.deactivate());
  }, [notify.activate, notify.severity, notify.title, notify.message, dispatch]);

  return null;
};

export default Notification;
